module.exports = __webpack_public_path__ + "static/compact3-a57ca612463c4cf740846f9e921ae9c4.png";